import { keyEmptyCheck } from 'aurora-utils/utils';

export const tabsValues = {
  EXISTING_REPRESENTATIVE: 0,
  ADD_NEW_REPRESENTATIVE: 1,
};

export const tabsData = [
  {
    label: keyEmptyCheck('existing_representative'),
    value: tabsValues.EXISTING_REPRESENTATIVE,
  },
  {
    label: keyEmptyCheck('add_representative'),
    value: tabsValues.ADD_NEW_REPRESENTATIVE,
  },
];

export const FETCH_REP_PAGE_SIZE = 5;

export const REQUIRED_DOCS = {
  POC: 'POA_DOC',
};

export const REPRESENTATIVE_REQUIRED_KEYS = {
  phoneNo: 'phoneNo',
  email: 'email',
  representativeType: 'representativeType',
  sourceOfAuthorization: 'source',
  authorizationNo: 'poaNumber',
  authorizationDate: 'authorizationDate',
};

export const REPRESENTATIVE_TYPES = [
  {
    label: keyEmptyCheck('guardian'),
    value: 'GUARDIAN',
  },
  {
    label: keyEmptyCheck('Agency'),
    value: 'AGENCY',
  },
  {
    label: keyEmptyCheck('Company_signatory'),
    value: 'COMPANY_SIGNATORY',
  },
];

export const SOURCE_OF_AUTHORIZATIONS = [
  {
    label: keyEmptyCheck('Abu_Dhabi_Court'),
    value: 'Abu_Dhabi_Court',
  },
  {
    label: keyEmptyCheck('inside_uae'),
    value: 'Inside_UAE',
  },
  {
    label: keyEmptyCheck('outside_uae'),
    value: 'Outside_UAE',
  },
];

export default {};
